export default __webpack_public_path__ + "static/media/p11.63d7fb00.jpg";